export default __webpack_public_path__ + "static/backend-as-a-service-2-b8180f68b7ff6b172e31e9e44a4024b5.png";